module.exports = __webpack_public_path__ + "media/images/unite5-9baec523fb37b116d1c02b027422d097.png";